import React, { useContext, useState } from 'react';
import get from 'lodash/get';
import { useDispatch } from 'react-redux';

import { Button } from 'src/presentation/components/agent_desktop_components';
import { Row, Section } from 'src/presentation/components/forms/Layout';
import { openAnonModule } from 'src/presentation/components/pages/sidekick/threads/actions/anonUiActions';
import useRouter from 'src/presentation/hooks/useRouter';
import Dropdown from 'src/presentation/components/forms/Dropdown';
import FormContext from 'src/presentation/contexts/FormContext';
import { SidekickThreadEditorContext } from 'src/presentation/components/pages/sidekick/threads/SidekickThreadEditorContext';

type SelectActionProps = {
  attr: string;
  disabled: boolean;
  options: { label: string; value: string }[];
  onChange: (name: string) => void;
};

const SelectAction = ({ attr, disabled, options, onChange }: SelectActionProps) => {
  const { anonymousModuleModalRef } = useContext(SidekickThreadEditorContext);

  const dispatch = useDispatch();
  const { history } = useRouter();

  const handleEditAction = () => {
    dispatch(openAnonModule({ history }));
    anonymousModuleModalRef.current?.show(disabled);
  };

  const { workingState } = useContext(FormContext);
  const [value, setValue] = useState(get(workingState, `${attr}.name`, ''));

  const handleChanges = value => {
    setValue(value);
    onChange(value);
  };

  return (
    <Section>
      <Row>
        <Dropdown
          allowEmptyValues
          data-aid="name"
          disabled={disabled}
          onChange={handleChanges}
          options={options}
          placeholder="Select Action"
          searchable
          value={value}
        />
        <Button onClick={handleEditAction} disabled={!value}>
          Edit
        </Button>
      </Row>
    </Section>
  );
};

export default SelectAction;
